import { type RefObject, useEffect, useState } from "react";

export const useInitialDimension = (ref: RefObject<HTMLElement>) => {
    const [width, setWidth] = useState<number | undefined>();
    const [height, setHeight] = useState<number | undefined>();
    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const { width, height } = el.getBoundingClientRect();
        setWidth(width);
        setHeight(height);
    }, [ref]);
    return [width, height];
};
